const setAlert = (type, text) => {
	return {
		type: "SET_ALERT",
		payload: {
			type, text,
		},
	};
};
const clearAlert = () => {
	return {
		type: "CLEAR_ALERT",
	};
};

export const alertActions = {
	setAlert,
	clearAlert,
};
